// Plans whose PAID entitlements include Autopilot. During a card-backed trial the
// entitlements payload exposes Free-level features (features.autopilot === false)
// until the first charge, so the plan key is the only signal that Autopilot is
// coming — this list must track the grid (src/lib/plans.js NEW_PLAN_DEFS: growth /
// pro / agency carry "Autopilot posting"; starter does not) plus legacy keys.
const AUTOPILOT_PLANS = new Set([
  // grid v1.1
  'growth',
  'pro',
  'agency',
  // legacy (pre-2026-07-07 tiers still on trials/grandfathered)
  'brand_pilot',
  'pilot_growth',
  'marketing_operator',
  'growth_plus',
  'multi_brand',
  'business',
  'enterprise',
]);

export function trialingAutopilotPlan(entitlements) {
  const plan = entitlements?.plan || entitlements?.planKey;
  return entitlements?.billingStatus === 'trialing' && AUTOPILOT_PLANS.has(plan);
}
